import React, { Suspense, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Panel,
  Form,
  FormControl,
  Button,
  InputGroup,
  Row,
} from "react-bootstrap";
import { navigate } from "raviger";
import _ from "lodash";
import CurrencyFormat from "react-currency-format";
import MaskedFormControl from "react-bootstrap-maskedinput";

import validations from "./Validations";

import withAuthentication from "../../hoc/withAuthentication";
import withLayout from "../../hoc/withLayout";
import Permission from "../../components/Permission/Permission";

import withForm from "../../hoc/withForm";
import InputCollectionInline from "../../components/InputCollection/InputCollectionInline";
import OptionsHelper from "../../lib/OptionsHelper";
import CheckboxInput from "../../components/CheckboxInput/CheckboxInput";

import { useAlertStore } from "../../store/providers/Alert";
import { useContractStore } from "../../store/providers/Contract";
import moment from "moment";

import {
  breadcrumbAddRoute,
  breadcrumbRemoveRoute,
} from "../../store/actions/breadcrumb";

import Spinner from "../../components/Spinner/Spinner";

import * as constants from "../../constants";
const InputCollection = React.lazy(() =>
  import("../../components/InputCollection/InputCollection")
);
const SideMenu = React.lazy(() => import("../../components/SideMenu/SideMenu"));
const PageHeader = React.lazy(() =>
  import("../../components/PageHeader/PageHeader")
);

function Contract(props) {
  const dispatch = useDispatch();

  const { addAlert } = useAlertStore();
  const {
    selectRecord,
    contractsData,
    newRecord,
    createRecord,
    updateRecord,
    listUsersRecords,
    data,
    clearData,
  } = useContractStore();
  const [isMounted, setIsMounted] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [isBusy, setIsBusy] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isDropdownsLoaded, setIsDropdownsLoaded] = useState(false);
  const [isdropdownChange, setIsdropdownChange] = useState(false);
  const pagePermission = constants.PERMISSION_CONTRACTS;
  const [hasPermission, setHasPermission] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [usersListData, setUsersListData] = useState([]);
  const [title, setTitle] = useState("");
  const [
    contractTerminationNoticePeriods,
    setContractTerminationNoticePeriods,
  ] = useState([]);
  const [terminationNoticePeriods, setTerminationNoticePeriods] = useState([]);
  const [paymentTimePeriods, setPaymentTimePeriods] = useState([]);
  const [canEdit, setCanEdit] = useState(false);

  const [terminationNoticeDate, setTerminationNoticeDate] = useState("");

  const cancelledHandler = () => {
    navigate("/contracts");
  };
  const terminationNoticeDateHandler = (expirationDate) => {
    const selectedPeriodId = props.formData?.terminationNoticePeriodId ?? data.body?.terminationNoticePeriodId;

    if (
      expirationDate &&
      selectedPeriodId &&
      terminationNoticePeriods?.length
    ) {
      const selectedOption = terminationNoticePeriods.find(
        (item) => parseInt(item.id) === parseInt(selectedPeriodId)
      );

      if (selectedOption) {
        const daysMatch = selectedOption.name.match(/(\d+)/);
        const daysToSubtract = daysMatch ? parseInt(daysMatch[1]) : 0;

        if (daysToSubtract) {
          const calculatedDate = moment(expirationDate)
            .subtract(daysToSubtract, "days")
            .format("MM/DD/YYYY");

          setTerminationNoticeDate(calculatedDate);
        }
      }
    } else {
      setTerminationNoticeDate("");
    }
  };

  const submittedHandler = (e) => {
    e.preventDefault();
    var valid = props.formValidate(validations);
    if (valid) {
      props.formSubmitted();
      setIsBusy(true);
      isNew
        ? createRecord(props.formData).then(() => {
            setIsBusy(false);
            navigate("/contracts");
          })
        : updateRecord({ ...props.formData, id: props.formData.id }).then(
            () => {
              setIsBusy(false);
              navigate("/contracts");
            }
          );
    }
  };

  useEffect(() => {
    if (!_.isEmpty(data)) {
      if (
        data.scope === "selectDropdownContractsData" &&
        data.status === "success"
      ) {
        if (!_.isEmpty(data.body.departments)) {
          let departmentsList = data.body.departments.map((selection) => {
            return {
              id: selection.id,
              name: selection.name,
            };
          });
          setDepartments(
            OptionsHelper({
              list: departmentsList,
              nameField: "name",
              includeBlank: true,
              includeBlankName: "Select...",
            })
          );
        }

        if (!_.isEmpty(data.body.contractTerminationNoticePeriods)) {
          let contractTerminationNoticePeriods =
            data.body.contractTerminationNoticePeriods.map((selection) => {
              return {
                id: selection.id,
                name: selection.name,
              };
            });
          setTerminationNoticePeriods(contractTerminationNoticePeriods);
          setContractTerminationNoticePeriods(
            OptionsHelper({
              list: contractTerminationNoticePeriods,
              nameField: "name",
              includeBlank: true,
              includeBlankName: "Select...",
            })
          );
          terminationNoticeDateHandler(props.formData["expirationDate"]);
        }

        if (!_.isEmpty(data.body.paymentTimePeriods)) {
          let paymentTimePeriods = data.body.paymentTimePeriods.map(
            (selection) => {
              return {
                id: selection.id,
                name: selection.name,
              };
            }
          );
          setPaymentTimePeriods(
            OptionsHelper({
              list: paymentTimePeriods,
              nameField: "name",
              includeBlank: true,
              includeBlankName: "Select...",
            })
          );
        }
        setIsDropdownsLoaded(true);
      }

      if (data.status === "success" && data.scope === "usersList") {
        setUsersListData(data.body);
      }

      if (
        !isLoaded &&
        isMounted &&
        (data.scope === "new" || data.scope === "select") &&
        data.status === "success"
      ) {
        if (data.body && data.body.id) {
          if (!_.isEmpty(data.body.startDate)) {
            data.body.startDate = moment(data.body.startDate).format(
              "YYYY-MM-DD"
            );
          }
          if (!_.isEmpty(data.body.expirationDate)) {
            const expirationDateMoment = moment(data.body.expirationDate);

            data.body.expirationDate =
              expirationDateMoment.format("YYYY-MM-DD");
            terminationNoticeDateHandler(expirationDateMoment.format("YYYY-MM-DD"));
          }
          if (!_.isEmpty(data.body.createdOn)) {
            data.body.createdOn = moment(data.body.createdOn).format(
              "YYYY-MM-DD"
            );
          }

          props.formInitialize(data.body);
          setIsLoaded(true);
          setTitle(data.body.vendorName);

          dispatch(
            breadcrumbAddRoute({
              key: "edit-contract",
              text: data.body.vendorName,
              path: {
                event: () => {
                  navigate(`/contracts/edit/${data.body.id}`);
                },
              },
            })
          );
        } else {
          dispatch(
            breadcrumbAddRoute({
              key: "new-contract",
              text: "new",
              path: {
                event: () => {
                  navigate(`/contracts/new`);
                },
              },
            })
          );
        }
      }

      if (data.status === "fail" || data.status === "error") {
        addAlert({
          key: constants.ALERT_SERVER_ERROR,
          text: <strong>{data.body}</strong>,
          type: constants.ALERT_TYPE_DANGER,
        });
        clearData();
      }

      if (!isNew && data.scope === "new" && data.status === "success") {
        setIsNew(true);
      }

      setIsBusy(
        data.status === "processing" &&
          (data.scope === "edit" ||
            data.scope === "update" ||
            data.scope === "create")
      );
    }
  }, [
    props,
    data,
    addAlert,
    clearData,
    isLoaded,
    isMounted,
    isDropdownsLoaded,
    isNew,
    dispatch,
  ]);

  useEffect(() => {
    if (!_.isEmpty(usersListData)) {
      const usersListOptions =
        usersListData &&
        usersListData.map((selection) => {
          return {
            id: selection.id,
            name: selection.firstName + " " + selection.lastName,
          };
        });
      setUsersList(
        OptionsHelper({
          list: usersListOptions,
          nameField: "name",
          includeBlank: true,
          includeBlankName: "Select...",
        })
      );
    }
  }, [usersListData]);

  useEffect(() => {
    if (!hasPermission) {
      return;
    }
    if (isMounted) {
      return;
    }

    if (!_.isEmpty(props.contractId)) {
      selectRecord({ contractId: props.contractId });
      setIsNew(false);
    } else {
      setIsNew(true);
      newRecord();
      setIsLoaded(true);
    }
    contractsData();
    listUsersRecords();

    dispatch(
      breadcrumbAddRoute({
        key: "contracts",
        text: "Contracts",
        path: {
          event: () => {
            dispatch(breadcrumbRemoveRoute(2));
            navigate("/contracts");
          },
        },
      })
    );

    setIsMounted(true);
  }, [
    hasPermission,
    props,
    selectRecord,
    newRecord,
    isMounted,
    listUsersRecords,
    contractsData,
  ]);

  useEffect(() => {
    return () => {
      dispatch(breadcrumbRemoveRoute());
    };
  }, [dispatch]);

  return (
    <>
      <SideMenu activeKey="contracts" />
      <div className="content-body">
        <Permission
          showDenied={true}
          pagePermission={pagePermission}
          hasPermission={hasPermission}
          setHasPermission={setHasPermission}
          setCanEdit={setCanEdit}
        />
        {hasPermission && isMounted && (
          <Suspense fallback={<Spinner text="Loading..." />}>
            <div style={{ paddingRight: "15px" }}>
              {!isNew && <PageHeader title={title} />}
              {isNew && <PageHeader title={"New Contract"} />}
              <Panel>
                <Panel.Body>
                  {!isLoaded ? <Spinner text="Loading Contract..." /> : (
                    <Form>
                      <Row>
                        <div className="col-md-6">
                          <InputCollection
                            required
                            labelText="Vendor / Contractor"
                            errorMessage={props.formValidationCheck(
                              "vendorName"
                            )}
                          >
                            <FormControl
                              id="vendorName"
                              onChange={(e) => {
                                props.formChanged(e.target.id, e.target.value);
                                if (!isNew) setTitle(e.target.value);
                              }}
                              autoComplete="off"
                              defaultValue={props.formData["vendorName"] || ""}
                              disabled={isBusy}
                            />
                          </InputCollection>
                        </div>
                      </Row>
                      <Row>
                        <div className="col-md-3">
                          <InputCollection
                            required
                            labelText="Contact Name"
                            errorMessage={props.formValidationCheck(
                              "contactName"
                            )}
                          >
                            <FormControl
                              id="contactName"
                              onChange={(e) =>
                                props.formChanged(e.target.id, e.target.value)
                              }
                              autoComplete="off"
                              defaultValue={props.formData["contactName"] || ""}
                              disabled={isBusy}
                            />
                          </InputCollection>
                        </div>
                        <div className="col-md-3">
                          <InputCollection
                            required
                            labelText="Contact Phone"
                            errorMessage={props.formValidationCheck(
                              "contactPhone"
                            )}
                          >
                            <MaskedFormControl
                              id="contactPhone"
                              onChange={(e) =>{
                                props.formChanged(e.target.id, e.target.value)
                              }
                              }
                              autoComplete="off"
                              maxLength={15}
                              mask="(111) 111-1111"
                              value={props.formData["contactPhone"] || ""}
                              disabled={isBusy}
                            />
                          </InputCollection>
                        </div>
                        <div className="col-md-3">
                          <InputCollection
                            required
                            labelText="Contact Email"
                            errorMessage={props.formValidationCheck(
                              "contactEmail"
                            )}
                          >
                            <FormControl
                              id="contactEmail"
                              onChange={(e) =>
                                props.formChanged(e.target.id, e.target.value)
                              }
                              autoComplete="off"
                              defaultValue={
                                props.formData["contactEmail"] || ""
                              }
                              disabled={isBusy}
                            />
                          </InputCollection>
                        </div>
                      </Row>
                      <Row>
                        <div className="col-md-3">
                          <InputCollection
                            required
                            labelText="Contract Start / Effective Date"
                            errorMessage={props.formValidationCheck(
                              "startDate"
                            )}
                          >
                            <FormControl
                              id="startDate"
                              name="startDate"
                              type="date"
                              onChange={(e) =>
                                props.formChanged(e.target.id, e.target.value)
                              }
                              autoComplete="off"
                              maxLength={10}
                              defaultValue={props.formData["startDate"] || ""}
                              disabled={isBusy}
                            />
                          </InputCollection>
                        </div>
                        <div className="col-md-3">
                          <InputCollection
                            required
                            labelText="Contract Expiration Date"
                            errorMessage={props.formValidationCheck(
                              "expirationDate"
                            )}
                          >
                            <FormControl
                              id="expirationDate"
                              name="expirationDate"
                              type="date"
                              onChange={(e) => {
                                props.formChanged(e.target.id, e.target.value);
                                terminationNoticeDateHandler(e.target.value);
                              }}
                              defaultValue={
                                props.formData["expirationDate"] || ""
                              }
                              maxLength={10}
                              autoComplete="off"
                              disabled={isBusy}
                            />
                          </InputCollection>
                        </div>
                        <div className="col-md-3">
                          <InputCollectionInline
                            required
                            labelText="Termination Notice Period"
                            errorMessage={props.formValidationCheck(
                              "terminationNoticePeriodId"
                            )}
                          >
                            <FormControl
                              id="terminationNoticePeriodId"
                              componentClass="select"
                              onChange={(e) => {
                                props.formChanged(e.target.id, e.target.value);
                                terminationNoticeDateHandler(
                                  props.formData["expirationDate"]
                                );
                                setIsdropdownChange(!isdropdownChange);
                              }}
                              value={
                                props.formData["terminationNoticePeriodId"] ||
                                ""
                              }
                              disabled={isBusy}
                            >
                              {contractTerminationNoticePeriods}
                            </FormControl>
                          </InputCollectionInline>
                        </div>
                        <div className="col-md-3">
                          <InputCollection labelText="Termination Notice Date">
                            <FormControl
                              id="terminationNoticeDate"
                              autoComplete="off"
                              maxLength={10}
                              defaultValue={terminationNoticeDate}
                              disabled={true}
                            />
                          </InputCollection>
                        </div>
                      </Row>
                      <Row>
                        <div
                          className="col-md-3"
                          style={{ marginBottom: "15px" }}
                        >
                          <CheckboxInput
                            className="form-control"
                            style={{ display: "inline" }}
                            noWrapper={true}
                            id="isAutoRenew"
                            value={props.formData["isAutoRenew"]}
                            changed={(id, value) => {
                              props.formChanged(id, !value);
                            }}
                          />
                          <span className="fieldtext fieldtextafter spaceafter">
                            Auto Renew
                          </span>
                        </div>
                        <div
                          className="col-md-3"
                          style={{ marginBottom: "15px" }}
                        >
                          <CheckboxInput
                            className="form-control"
                            style={{ display: "inline" }}
                            noWrapper={true}
                            id="isAutoPay"
                            value={props.formData["isAutoPay"]}
                            changed={(id, value) => {
                              props.formChanged(id, !value);
                            }}
                          />
                          <span className="fieldtext fieldtextafter spaceafter">
                            Auto Pay
                          </span>
                        </div>
                      </Row>
                      <Row>
                        <div className="col-md-3">
                          <InputCollection
                            required
                            labelText="Contract Financial Obligation"
                            errorMessage={props.formValidationCheck(
                              "contractFinancialObligation"
                            )}
                          >
                            <InputGroup style={{ display: "flex" }}>
                              <InputGroup.Addon
                                style={{
                                  display: "flex",
                                  flexBasis: "40px",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                $
                              </InputGroup.Addon>
                              <CurrencyFormat
                                id="contractFinancialObligation"
                                className="form-control"
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                                onChange={(e) => {
                                  props.formChanged(
                                    e.target.id,
                                    e.target.value
                                  );
                                }}
                                value={
                                  props.formData[
                                    "contractFinancialObligation"
                                  ] || ""
                                }
                                style={{
                                  position: "relative",
                                  display: "inline-flex",
                                }}
                              ></CurrencyFormat>
                            </InputGroup>
                          </InputCollection>
                        </div>
                        <div className="col-md-3">
                          <InputCollectionInline
                            required
                            labelText="Payment Time Period"
                            errorMessage={props.formValidationCheck(
                              "paymentTimePeriodId"
                            )}
                          >
                            <FormControl
                              id="paymentTimePeriodId"
                              componentClass="select"
                              onChange={(e) => {
                                props.formChanged(e.target.id, e.target.value);
                                setIsdropdownChange(!isdropdownChange);
                              }}
                              value={props.formData["paymentTimePeriodId"]}
                              disabled={isBusy}
                            >
                              {paymentTimePeriods}
                            </FormControl>
                          </InputCollectionInline>
                        </div>
                      </Row>
                      <Row>
                        <div className="col-md-3">
                          <InputCollectionInline
                            required
                            labelText="Department"
                            errorMessage={props.formValidationCheck(
                              "departmentId"
                            )}
                          >
                            <FormControl
                              id="departmentId"
                              componentClass="select"
                              onChange={(e) => {
                                props.formChanged(e.target.id, e.target.value);
                                setIsdropdownChange(!isdropdownChange);
                              }}
                              value={props.formData["departmentId"]}
                              disabled={isBusy}
                            >
                              {departments}
                            </FormControl>
                          </InputCollectionInline>
                        </div>
                        <div className="col-md-3">
                          <InputCollectionInline
                            required
                            labelText="Signed By"
                            errorMessage={props.formValidationCheck(
                              "signedById"
                            )}
                          >
                            <FormControl
                              id="signedById"
                              componentClass="select"
                              onChange={(e) => {
                                props.formChanged(e.target.id, e.target.value);
                                setIsdropdownChange(!isdropdownChange);
                              }}
                              value={props.formData["signedById"]}
                            >
                              {usersList}
                            </FormControl>
                          </InputCollectionInline>
                        </div>
                        <div className="col-md-3">
                          <InputCollection
                            required
                            labelText="Contract Notification Email"
                            helpText={'The email entered here will receive emailed notifications surrounding this contract.  Please be sure to enter a group email address and not a personal email address for these notifications'}
                            errorMessage={props.formValidationCheck(
                              "notificationEmail"
                            )}
                          >
                            <FormControl
                              id="notificationEmail"
                              onChange={(e) =>
                                props.formChanged(e.target.id, e.target.value)
                              }
                              autoComplete="off"
                              defaultValue={props.formData["notificationEmail"] || ""}
                              disabled={isBusy}
                            />
                          </InputCollection>
                        </div>
                      </Row>
                      <Row>
                        {props.formData["id"] && (
                          <div className="col-md-3">
                            <InputCollection labelText="Created By">
                              <FormControl
                                id="createdBy"
                                defaultValue={props.formData["createdBy"] || ""}
                                disabled={true}
                              />
                            </InputCollection>
                          </div>
                        )}
                        {props.formData["id"] && (
                          <div className="col-md-3">
                            <InputCollection labelText="Created On Date">
                              <FormControl
                                id="createdOn"
                                name="createdOn"
                                type="date"
                                defaultValue={props.formData["createdOn"] || ""}
                                maxLength={10}
                                autoComplete="off"
                                disabled={true}
                              />
                            </InputCollection>
                          </div>
                        )}
                      </Row>
                      <div className="form-action-buttons">
                        <Button
                          bsStyle="default"
                          onClick={() => cancelledHandler()}
                          className="button-group-margin"
                          disabled={isBusy}
                        >
                          <i className="fa fa-undo button-icon"></i>
                          Back
                        </Button>
                        <Button
                          bsStyle="danger"
                          variant="danger"
                          onClick={(e) => submittedHandler(e)}
                          type="submit"
                          className="button-group-margin"
                          disabled={!canEdit || isBusy}
                        >
                          <i className="fa fa-save button-icon"></i>
                          {isBusy ? "Saving..." : "Save & Exit"}
                        </Button>
                      </div>
                    </Form>
                  )}
                </Panel.Body>
              </Panel>
            </div>
          </Suspense>
        )}
      </div>
    </>
  );
}

export default withAuthentication(withLayout(withForm(Contract)));
